import UserProfile from "@/domain/entities/user/UserProfile";
import UserType from "@/domain/enums/UserType";
import { UserProfile as UserProfileMailvista } from "@cs_teamwaydev/mailvista-sdk_react";
import { profileToDomainMapper, profileToSDKMapper } from "./profileMapper";
import { settingsToDomainMapper, settingsToSDKMapper } from "./settingsMapper";
import {
    statusDetailToDomainMapper,
    statusDetailToSDKMapper,
} from "./statusDetailMapper";

const userToDomainMapper = (user: UserProfileMailvista): UserProfile =>
    new UserProfile({
        id: user.id,
        userId: user.userId,
        tenantId: user.tenantId,
        userType: user.userType as UserType,
        firstName: user.firstName,
        lastName: user.lastName,
        teamId: user.teamId,
        profile: profileToDomainMapper(user.profile),
        settings: settingsToDomainMapper(user.settings),
        monthlyAnalyzedMailCount: user.monthlyAnalyzedMailCount,
        monthlySpentTokenCount: user.monthlySpentTokenCount,
        nextQuotaRenewalDate: user.nextQuotaRenewalDate,
        statusDetail: statusDetailToDomainMapper(user.statusDetail),
        isUserDisabled: user.isUserDisabled,
        isOnboardingDone: user.isOnboardingDone,
        photoURL: user.photoURL,
        phoneNumber: user.phoneNumber,
    });

const userToSDKMapper = (user: UserProfile): UserProfileMailvista => ({
    id: user.id,
    userId: user.userId,
    tenantId: user.tenantId,
    userType: user.userType as UserType,
    profile: profileToSDKMapper(user.profile),
    firstName: user.firstName,
    lastName: user.lastName,
    teamId: user.teamId,
    settings: settingsToSDKMapper(user.settings),
    monthlyAnalyzedMailCount: user.monthlyAnalyzedMailCount,
    monthlySpentTokenCount: user.monthlySpentTokenCount,
    statusDetail: statusDetailToSDKMapper(user.statusDetail),
    isUserDisabled: user.isUserDisabled,
    isOnboardingDone: user.isOnboardingDone,
    photoURL: user.photoURL,
    phoneNumber: user.phoneNumber,
    nextQuotaRenewalDate: user.nextQuotaRenewalDate,
});

export { userToDomainMapper, userToSDKMapper };
